<template>
    <div
        v-loading="loading"
        class="py-5">
        <div
            v-if="editable"
            class="mb-2">
            <hts-form-upload
                ref="uploadFile"
                :uri-params="uriParams"
                :api="$urlClient.monitoring.journey.file.upload"
                @upload-success="refresh" />
        </div>
        <div v-if="list.length">
            <div class="hidden md:grid grid-cols-5 gap-2 p-2 font-medium border-b">
                <div>
                    Tên file
                </div>
                <div>
                    Ngày tạo
                </div>
                <div>
                    Tác vụ
                </div>
                <div>
                    Tạo bởi
                </div>
            </div>
            <template
                v-for="(file, index) in list"
                :key="index">
                <div class="hidden md:grid grid-cols-5 gap-2 p-2">
                    <div class="truncate">
                        <hts-tooltip reference-class="truncate">
                            <span>
                                {{ file.originalName || file.fileOriginName || file.fileName }}
                            </span>
                            <template #reference>
                                <span class="truncate">
                                    {{ file.originalName || file.fileOriginName || file.fileName }}
                                </span>
                            </template>
                        </hts-tooltip>
                    </div>
                    <div>
                        {{ $formatters.datetime(file.createdAt) }}
                    </div>
                    <div>
                        {{ file.taskName || 'Khác' }}
                    </div>
                    <div>
                        <hts-user
                            :id="file.createdBy"
                            inline
                            size="mini" />
                    </div>
                    <div class="col-span-2">
                        <a
                            :href="$formatters.cdnUrl(file.path)"
                            target="_blank">
                            <img
                                v-if="file.mimeType && file.mimeType.includes('image')"
                                :src="$formatters.cdnUrl(file.path)"
                                class="max-h-20 max-w-full shadow border" >
                            <span
                                v-else
                                class="underline text-blue-500">
                                Mở file
                            </span>
                        </a>
                    </div>
                </div>
                <div class="block md:hidden p-2 border rounded shadow">
                    <div>
                        <span class="mr-1">
                            Tên file:
                        </span>
                        <span class="font-medium">
                            {{ file.originalName || file.fileOriginName || file.fileName }}
                        </span>
                    </div>
                    <div>
                        <span class="mr-1">
                            Ngày tạo:
                        </span>
                        <span class="font-medium">
                            {{ $formatters.datetime(file.createdAt) }}
                        </span>
                    </div>
                    <div>
                        <span class="mr-1">
                            Tác vụ
                        </span>
                        <span class="font-medium">
                            {{ file.taskName || 'Khác' }}
                        </span>
                    </div>
                    <div>
                        <span class="mr-1">
                            Tạo bởi
                        </span>
                        <hts-user
                            :id="file.createdBy"
                            inline
                            size="mini" />
                    </div>
                    <div class="mt-1">
                        <a
                            :href="file.url"
                            target="_blank">
                            <img
                                v-if="file.mimeType && file.mimeType.includes('image')"
                                :src="file.url"
                                class="max-h-20 max-w-full shadow border" >
                            <span
                                v-else
                                class="underline text-blue-500">
                                Mở file
                            </span>
                        </a>
                    </div>
                </div>
            </template>
        </div>
        <div v-else>
            No documents.
        </div>
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  journeyId: {
    type: String as PropType<string | null>,
    required: true
  },
  editable: Boolean
})

const { journeyId } = toRefs(props)
const loading = ref(false)
const list = ref<any[]>([])
const uploadFile = ref()
const getFiles = () => {
  if (!journeyId.value) {
    return
  }
  list.value = []
  loading.value = true
  $api($urlClient.monitoring.journey.file.get, { uriParams: { ID: journeyId.value } }).then(({ data }: any) => {
    list.value = (data?.value || {}).data || []
    loading.value = false
  })
}
const openUpload = () => {
  if (uploadFile.value) {
    uploadFile.value.open()
  }
}
const uriParams = computed(() => ({ ID: journeyId.value }))
onMounted(() => {
  getFiles()
})

const refresh = $lodash.debounce(getFiles, 500)

defineExpose({ refresh })
</script>
